import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { CompanyProfileAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-company-profile-audit-list',
  templateUrl: './company-profile-audit-list.component.html',
  styleUrls: ['./company-profile-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyProfileAuditListComponent implements OnInit {
  @Input() companyProfileId: number;
  @Input() loading: boolean;
  @Input() companyProfileAudits: CompanyProfileAudit[];

  @Output() loadCompanyProfile = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadCompanyProfile.emit(this.companyProfileId);
  }

  onNextPage() {
    this.nextPage.emit(this.companyProfileId);
  }
}
